
















import { Component, Prop, Vue } from 'vue-property-decorator';
import InformationRow from '@/components/display/information-row.vue';

@Component({
	components: { InformationRow },
})
export default class NotesRow extends Vue {
	@Prop({ required: true })
	public notes!: string | null;
}
